import { createIcon } from '../../icon';

import ApplePaySvg from './apple-pay.svg';
import GooglePaySvg from './google-pay.svg';
import VisaSvg from './visa.svg';
import PaypalSvg from './paypal.svg';
import MastercardSvg from './mastercard.svg';
import AmexSvg from './amex.svg';
import CryptoPaymentsSvg from './crypto-payments.svg';
import BitcoinSvg from './bitcoin.svg';

export const ApplePayIcon = createIcon(ApplePaySvg, 'ApplePayIcon', [29, 12]);
export const GooglePayIcon = createIcon(
  GooglePaySvg,
  'GooglePayIcon',
  [30, 12]
);
export const VisaIcon = createIcon(VisaSvg, 'VisaIcon', [37, 12]);
export const PaypalIcon = createIcon(PaypalSvg, 'PaypalIcon', [47, 12]);
export const MastercardIcon = createIcon(
  MastercardSvg,
  'MastercardIcon',
  [49, 12]
);
export const AmexIcon = createIcon(AmexSvg, 'AmexIcon', [52, 12]);
export const CryptoPaymentsIcon = createIcon(
  CryptoPaymentsSvg,
  'CryptoPaymentsIcon',
  [56, 12]
);
export const BitcoinIcon = createIcon(BitcoinSvg, 'BitcoinIcon', [58, 12]);
